const LightText = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '14px',
  color: '#909090'

};

export default LightText;

export const LightDark = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '14px',
  color: '#303030'

};
export const Lightly = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '14px',
  color: '#606060'

};
export const Lightight = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '14px',
  color: '#808080'

};
export const DarkBold = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '14px',
  color: '#303030'

};
export const LighterBold = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '14px',
  color: '#909090'

};
export const BigText = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '24px',
  color: '#000000'

};
export const TwntyText = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontStyle: 'normal',
  fontSize: '21px',
  color: '#B2B2B2'


};
export const BigTexts = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '20px',
  color: '#000000'

};
export const BigTextbold = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontStyle: 'normal',
  fontSize: '20px',
  color: '#303030'

};

export const BigerTexts = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontStyle: 'normal',
  fontSize: '22px',
  color: '#303030'

};
export const LighterBig = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '18px',
  color: '#303030'

};
export const BrigtherBig = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontStyle: 'normal',
  fontSize: '18px',
  color: '#303030'

};
export const LighteroneBig = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '18px',
  color: '#909090'

};
export const LightOne = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '16px',
  color: '#606060'

};
export const DarkOne = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontStyle: 'normal',
  fontSize: '16px',
  color: '#000000'

};
export const middleOne = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '16px',
  color: '#000000'

};
export const lastOne = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '16px',
  color: '#303030'

};
export const smallText = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '12px',
  color: '#606060'

};
export const smallDarkText = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '12px',
  color: '#303030'

};
export const smallLighterText = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '12px',
  color: '#909090'

};
export const smallLighItalic = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontStyle: 'Italic',
  fontSize: '12px',
  color: '#909090'



};
export const smallestText = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '10px',
  color: '#909090'

};
export const btnfont = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontStyle: 'Medium',
  fontSize: '14px',
  color: '#00AFEF'

};
export const pendingtxt = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontStyle: 'Regular',
  fontSize: '12px',
  color: '#A39D00", '
};